import * as z from 'zod';

export const rolesSchema = z.object({
  President: z.string().trim().min(1, { message: 'Please select a President' }),
  Secretary: z.string().trim().min(1, { message: 'Please select a Secretary' }),
  Treasurer: z.string().trim().min(1, { message: 'Please select a Treasurer' }),
});

export type RolesSchemaFields = z.infer<typeof rolesSchema>;
